import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import { SectionTitle } from '../SectionTitle';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';

export const SafeSection = (): JSX.Element => {
  const { t } = useTranslate();
  const { ref } = useAttentionTracker({ sectionName: 'main_safe' });

  return (
    <section
      className="relative md:space-y-32 space-y-16 md:max-w-homepage px-4 md:px-10"
      ref={ref}
    >
      <SectionTitle title={t.home.MAIN_SAFE_TITLE} description={t.home.MAIN_SAFE_DESC} isDark />
      <div className="space-y-8">
        <SafeItem
          title={t.home.MAIN_SAFE_ITEM_1_TITLE}
          description={t.home.MAIN_SAFE_ITEM_1_DESC}
          data={t.home.MAIN_SAFE_ITEM_1_DATA}
          hasChevron
        />
        <SafeItem
          title={t.home.MAIN_SAFE_ITEM_2_TITLE}
          description={t.home.MAIN_SAFE_ITEM_2_DESC}
          data={t.home.MAIN_SAFE_ITEM_2_DATA}
          hasChevron
        />
        <SafeItem
          title={t.home.MAIN_SAFE_ITEM_3_TITLE}
          description={t.home.MAIN_SAFE_ITEM_3_DESC}
          data={t.home.MAIN_SAFE_ITEM_3_DATA}
        />
      </div>
    </section>
  );
};

const SafeItem = ({
  title,
  description,
  data,
  hasChevron,
}: {
  title: string;
  description: string;
  data: string;
  hasChevron?: boolean;
}) => {
  return (
    <div className="max-w-[678px] flex flex-wrap md:flex-nowrap gap-3 justify-between bg-white/10 mx-auto p-5 md:p-8 rounded-lg md:rounded-3xl">
      <div className="md:flex-1 space-y-1.5 md:space-y-3.5">
        <h5 className="text-base md:text-2xl bg-clip-text text-transparent bg-gradient-pastel font-semibold">
          {title}
        </h5>
        <p
          className="text-white text-sm md:text-lg max-w-full"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
      <div className="w-fit flex items-center gap-2.5 text-xs md:text-lg text-black py-2 px-3 md:py-4 md:px-5 rounded-md bg-white h-fit">
        <span>{data}</span>
        {hasChevron && <ChevronIcon />}
      </div>
    </div>
  );
};

const ChevronIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6.5L8 10.5L4 6.5"
        stroke="#888888"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
